import { jsx } from "@builder.io/qwik/jsx-runtime";
import { component$, useStyles$, useContext, useSignal, useTask$, $, sync$, Slot } from "@builder.io/qwik";
import { modalContextId } from "./modal-context.qwik.mjs";
import styles from "./modal.css.qwik.mjs";
import { useModal } from "./use-modal.qwik.mjs";
import { isServer } from "@builder.io/qwik/build";
import { enableBodyScroll } from "body-scroll-lock-upgrade";
const HModalPanel = component$((props) => {
  useStyles$(styles);
  const { activateFocusTrap, closeModal, deactivateFocusTrap, showModal, trapFocus, wasModalBackdropClicked } = useModal();
  const context = useContext(modalContextId);
  const panelRef = useSignal();
  useTask$(async function toggleModal({ track, cleanup }) {
    const isOpen = track(() => context.showSig.value);
    if (!panelRef.value)
      return;
    const focusTrap = await trapFocus(panelRef.value);
    if (isOpen) {
      const storedRequestAnimationFrame = window.requestAnimationFrame;
      window.requestAnimationFrame = () => 42;
      await showModal(panelRef.value);
      window.requestAnimationFrame = storedRequestAnimationFrame;
      activateFocusTrap(focusTrap);
    } else {
      await closeModal(panelRef.value);
    }
    cleanup(async () => {
      if (isServer)
        return;
      await deactivateFocusTrap(focusTrap);
      if (!panelRef.value)
        return;
      enableBodyScroll(panelRef.value);
    });
  });
  useTask$(async ({ track }) => {
    track(() => context.showSig.value);
    if (context.showSig.value) {
      await context.onShow$?.();
    } else {
      await context.onClose$?.();
    }
  });
  const closeOnBackdropClick$ = $(async (e) => {
    if (context.alert === true || context.closeOnBackdropClick === false) {
      return;
    }
    if (!(e.target instanceof HTMLDialogElement)) {
      return;
    }
    if (await wasModalBackdropClicked(panelRef.value, e)) {
      context.showSig.value = false;
    }
  });
  const handleKeyDownSync$ = sync$((e) => {
    const keys = [
      " ",
      "Enter"
    ];
    if (e.target instanceof HTMLDialogElement && keys.includes(e.key)) {
      e.preventDefault();
    }
    if (e.key === "Escape") {
      e.preventDefault();
    }
  });
  const handleKeyDown$ = $((e) => {
    if (e.key === "Escape") {
      context.showSig.value = false;
      e.stopPropagation();
    }
  });
  return /* @__PURE__ */ jsx("dialog", {
    ...props,
    id: `${context.localId}-root`,
    "aria-labelledby": `${context.localId}-title`,
    "aria-describedby": `${context.localId}-description`,
    // TODO: deprecate data-state in favor of data-open, data-closing, and data-closed
    "data-state": context.showSig.value ? "open" : "closed",
    "data-open": context.showSig.value && "",
    "data-closed": !context.showSig.value && "",
    role: context.alert === true ? "alertdialog" : "dialog",
    ref: panelRef,
    onKeyDown$: [
      handleKeyDownSync$,
      handleKeyDown$,
      props.onKeyDown$
    ],
    onClick$: async (e) => {
      e.stopPropagation();
      await closeOnBackdropClick$(e);
    },
    children: /* @__PURE__ */ jsx(Slot, {})
  });
});
export {
  HModalPanel
};
